import { gql } from "@apollo/client";

export const LOGIN = gql`
    query gqlLogin($sUsername: String!, $sPassword: String!) {
        data: gqlLogin(sUsername: $sUsername, sPassword: $sPassword) {
            nID
            sUsername
            token
        }
    }
`;

export const RETRIEVE_USER_RESTAURANT = gql`
    query gqlRetrieveUsersRestaurant($nIDRestaurant: Int!) {
        data: gqlRetrieveUsersRestaurant(nIDRestaurant: $nIDRestaurant) {
            nID
            sName
            sSurname
        }
    }
`;

export const RETRIEVE_USER_RESTAURANT_BY_ID = gql`
    query gqlRetrieveUserRestaurantById($nID: Int!, $nIDRestaurant: Int!) {
        data: gqlRetrieveUserRestaurantById(nID: $nID, nIDRestaurant: $nIDRestaurant) {
            nID
            sName
            sSurname
            sPassword
        }
    }
`;

export const LOGIN_USER_RESTAURANT = gql`
    query gqlRetrieveUserRestaurantByPassword($nCode: String!, $nIDRestaurant: Int!) {
        data: gqlRetrieveUserRestaurantByPassword(nCode: $nCode, nIDRestaurant: $nIDRestaurant) {
            nID
            sName
            sSurname
        }
    }
`;